import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Scissors } from "lucide-react";
import api from "@/lib/api";
import { num, fmtDate } from "@/lib/format";

export default function RijekReminderList() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/repairs?status=MENUNGGU_DIAMBIL,DIAMBIL").then((r) => setRows(r.data.filter((x) => (x.label || "").includes("RIJEK")))).catch(() => {}); }, []);
  if (rows.length === 0) return null;
  const total = rows.reduce((a, r) => a + (r.qty || 0), 0);
  return (
    <div className="bg-orange-50 border-2 border-orange-400 rounded-lg p-4 dark:bg-orange-500/10 dark:border-orange-500/50" data-testid="dashboard-rijek-reminder">
      <div className="flex items-center gap-2 text-sm font-extrabold text-orange-900 dark:text-orange-200"><Scissors className="w-4 h-4" />PENGINGAT RIJEK PERBAIKAN — {num(total)} PCS masih di worker ({rows.length} tiket terbuka)</div>
      <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-1 text-xs text-orange-800 dark:text-orange-200">
        {rows.slice(0, 12).map((r) => <Link key={r.repair_id} to="/panggil" state={{ wid: r.worker_id }} className="flex justify-between gap-2 hover:underline" data-testid={`rijek-open-${r.repair_id}`}>
          <span><span className="mono font-bold">{r.worker_id}</span> {r.worker_name} · <span className="data-raw">{r.product_name}</span> · {r.label}</span>
          <span className="mono font-bold shrink-0">{num(r.qty)} PCS · {fmtDate(r.source_date)}</span>
        </Link>)}
      </div>
      {rows.length > 12 && <div className="text-[11px] text-orange-700 dark:text-orange-300 mt-1">+{rows.length - 12} tiket lainnya</div>}
    </div>
  );
}
